<template>
  <div class="wrapper">
    <div class="pb-0">
      <div>
        <h5 class="p-2 text-white text-bold title">प्रिती बाट युनिकोड</h5>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-6 col-sm-12 col-xs-12">
          <div class="px-3 d-flex justify-content-between spacer">
            <label for="">प्रीति फन्टका अक्षरहरु </label>
            <label> </label>
          </div>

          <textarea
            rows="15"
            id="preeti"
            v-model="preetiString"
            class="form-control"
          >
          </textarea>
        </div>
        <div class="col-lg-12 col-md-6 col-sm-12 col-xs-12 py-2">
          <div class="d-flex px-3 justify-content-between spacer">
            <label for="">युनिकोड फन्टका अक्षरहरू </label>
            <label>Special Characters : क्ष ज्ञ ॐ ण र्‍य र्‍ ऋ ॠ ङ ञ । </label>
          </div>

          <textarea
            rows="14"
            id="unicode"
            v-model="unicodeString"
            class="form-control"
          >
          </textarea>
        </div>
      </div>
    </div>
    <Intro mode="p2u" />
  </div>
</template>

<script>
import Intro from "./Intro";
// const preeti = require("preeti");

// const { preetify } = require("../mapper");
import { convertToUnicode } from "./preeti_to_unicode";
export default {
  components: { Intro },
  data() {
    return {
      preetiString: "",
    };
  },
  computed: {
    unicodeString() {
      // return "";
      return convertToUnicode(this.preetiString);
    },
  },
};
</script>

<style scoped>
#preeti {
  font-family: "Preeti";
  font-size: 1.5em;
  font-weight: normal;
}
#unicode {
  font-family: "Mukta";
}
</style>
